import Image from "next/image";

import cn from "classnames";
import { Image as ImageType } from "sanity";

import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { RichText as RichTextType } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

export const ReasonsToBuyItem4Column = ({
  icon,
  title,
  description,
  className,
  layout = "stacked",
}: ReasonsToBuyItem4ColumnProps) => {
  const imageUrl = icon ? urlFor(icon).url() : null;
  const inline = layout === "inline";

  return (
    <div
      className={cn(
        "mx-5 rounded-[20px] md:mx-0",
        inline
          ? "flex flex-row items-start gap-3 text-left"
          : "border-secondary-100 flex flex-[1_0_0] flex-col items-start justify-center gap-2 self-stretch border bg-white p-3 pt-1 text-center lg:p-8 lg:pt-[5px]",
        className,
      )}>
      <div className="text-primary flex size-6 shrink-0 items-center justify-center lg:size-1">
        {imageUrl ? (
          <Image
            src={imageUrl}
            alt=""
            width={56}
            height={56}
            className="size-full object-contain"
            unoptimized
          />
        ) : null}
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <Text
          variant={inline ? "subtitle2" : "h6"}
          component="h3"
          className="text-secondary-100">
          {title}
        </Text>
        <RichText>{description}</RichText>
      </div>
    </div>
  );
};

export type ReasonsToBuyItem4ColumnProps = {
  icon?: ImageType;
  title: string;
  description?: RichTextType;
  className?: string;
  layout?: "stacked" | "inline";
};
